<template>
    <base-steps ref="stepper" hideButtons class="d-flex flex-column" style="min-height: 100%; align-items: stretch;">
        <div :class="product.sizes.length == 1 ? 'inactive': ''">
            <base-card>
                <base-question :text="`Selecione um tamanho:` " class="question-step"/>
                <div v-for="(size, j) in product.sizes" :key="j" class="option-step">
                    <base-radio :label="size.name" class="mb_0" :value="selectedSize" :option="size._id" :family="'options'" @change="(v, e) => checkSize(e, size)" />
                    <p class="price-step">{{(+size.price).toFormat(StringLanguage.currencyConfigs)}}</p>
                </div>
            </base-card>
        </div>
        <div :class="!category.extra_ingredients || category.extra_ingredients.length == 0 ? 'inactive' : '' ">
            <base-card>
                <base-question text="Extras"/>
                <div class="option-step" v-for="(extra, i) in category.extra_ingredients" :key="i">
                    <base-checkbox :label="extra.name" :defaultValue="1" v-model="extra.quantity" :checked="!!extra.quantity" @change="addIngredientExtra"/>
                    <p class="price-step">{{(+getItemPrice(extra) || 0).toFormat(StringLanguage.currencyConfigs)}}</p>
                </div>
            </base-card>
        </div>
        <div>
            <base-card>
                <base-question text="Alguma observação?"/>
                <base-textarea label="Insira uma observação" rows="5" v-model="product.observation" class="mb_5" />
            </base-card>
        </div>
    </base-steps>
</template>
<script>

import Vue from 'vue'
import BaseSteps from '@/components/Steps'
import BaseCard from '@/components/Card'
import BaseQuestion from '@/components/Question'
import BaseRadio from '@/components/Radio'
import BaseCheckbox from '@/components/Checkbox'
import BaseTextarea from '@/components/Textarea'
import BaseDrawer from '@/components/Drawer'
import BaseButton from '@/components/Button'
import Builder from 'easyjs/lib/Schema/Components/Builder'

const stepQuestions = {
    SIZE: 1,
    EXTRA_INGREDIENTS: 2,
    OBSERVATION: 3
}

export default {
    components: {
        BaseSteps,
        BaseCard,
        BaseQuestion,
        BaseRadio,
        BaseCheckbox,
        BaseTextarea,
        BaseDrawer,
        BaseButton
    },
    props: {
        product: { type: Object },
        category: { type: Object }
    },
    created () {
        this.$emit('updatePrice', this.product)
    },
    mounted() {
        this.selectedSize = this.$props.product.sizes[0]._id;
        if(this.$props.product.sizes.length == 1) {
            this.$props.product.sizes[0].quantity = 1;
            if (this.$props.product.extra_ingredients.length == 0) {
                this.$refs.stepper.next();
            }
            this.$refs.stepper.next();
        }

        this.$emit('updatePrice', this.product)
    },
    data () {
        return {
            dataProduct: '',
            selectedSize: ''
        }
    },
    methods: {
        getAvailableSteps() {
            return [
                this.product.sizes.length == 1 ? 0 : 1,
                !this.category.extra_ingredients || this.category.extra_ingredients.length == 0 ? 0 : 1,
                1
            ];
        },
        next() {
            if(this.$refs.stepper) {
                let availableSteps = this.getAvailableSteps();
                let currentQuestion = this.$refs.stepper.current;

                if(currentQuestion == stepQuestions.SIZE && availableSteps[0] === 1) {
                    if(!this.selectedSize) {
                        alert(`Por favor, selecione um tamanho!`);
                        return false;
                    }
                }

                if(availableSteps[currentQuestion] == 0) {
                    this.$refs.stepper.current++;
                }

                this.$emit('selectStepSize', this.getSizedProduct().sizes);

                this.$refs.stepper.next();
            }
        },
        prev() {
            if(this.$refs.stepper) {
                let availableSteps = this.getAvailableSteps();
                if(this.$refs.stepper.current == 2 && !availableSteps[0]) {
                    return;
                }

                if(this.$props.product.extra_ingredients.length == 0 && this.$props.product.sizes.length == 1) {
                    return
                }

                for(let x = this.$refs.stepper.current - 2; x >= 0; x--) {
                    if(availableSteps[x]) {
                        this.$refs.stepper.current = x + 1;
                        return;
                    }
                }
                this.$refs.stepper.prev();
            }
        },
        cloneObject(obj) {
            return Builder.mountSchema(Object.clone(obj));
        },
        addIngredientExtra() {
            Vue.set(this.product, 'extra_ingredients', this.category.extra_ingredients.filter(i => i.quantity > 0))
            this.$emit('updatePrice', this.getSizedProduct());
        },
        getSizedProduct() {
            let tmpCatalog = Builder.factory('Catalog');
            let tmpProduct = this.cloneObject(this.product);
            tmpCatalog.addItems(tmpProduct);
            Builder.executeOnSchema(tmpCatalog, (item) => {
                item.sizes = item.sizes.filter(s => this.selectedSize == s._id)
            });

            return tmpProduct
        },
        getItemPrice(item) {
            if(this.selectedSize && item.sizes.length > 0) {
                return item.sizes.filter(s => this.selectedSize == s._id)[0].price
            }
            return item.price;
        },
        checkSize(event, size) {
            this.selectedSize = size._id;
            this.$emit('updatePrice', this.getSizedProduct())
        },
        checkOption(event, question, option, multi) {
            event = event.target.checked;
            question.quantity = 0;
            question.items.forEach(o => {
                if(question.min == 1 && question.max == 1) {
                    o.quantity = 0;
                }

                if(o._id == option._id) {
                    question.quantity = 1;
                    Vue.set(o, 'quantity', event ? 1 : 0)
                }
            });

            this.$emit('updatePrice', this.getSizedProduct())
        },
    }
}
</script>
<style scoped>
    .option-step{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 25px;
    }

    .price-step{
        font-size: 1.2em;
        color: #AAAAABD4;
    }

    .mms{
        padding: 10px;
        background: var(--box-up);
        border: 1px solid var(--box-up);
        border-radius: 3px;
        font-size: 1.2em;
        color: #999;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
    }
</style>